import React from "react";
import * as Styles from "./styles/NavigationStyles";
import * as StepStyles from "./styles/NavigationStepStyles";
import * as IconWrapper from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import * as Type from "../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import TradeInAemNavigationItemsDesktop from "./TradeInAemNavigationItemsDesktop";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { TradeInAemLabel, tradeInAemNavStepLabels } from "../../../../utils/labels";
import useTradeInAemNavigation from "../../../../hooks/useTradeInAemNavigation";
import { useTradeInAemSelector } from "../../../../redux/store";
import TradeInAemNavigationItemsMobile from "./TradeInAemNavigationItemsMobile";

const TradeInAemNavigation = ({ insideModal }: { insideModal?: boolean }): JSX.Element => {
    const step = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const { currentStep, navigationOpen, setNavigationOpen } = useTradeInAemNavigation();

    return (
        <Styles.StickyWrapper zIndexName="navBar" disabled={insideModal} showBorder>
            <Styles.NavHeader>
                <Type.H4>
                    <TradeInAemLabel label="tradeInAemNavigationTitle" />
                </Type.H4>
            </Styles.NavHeader>
            <Styles.DesktopNav insideModal={insideModal}>
                <TradeInAemNavigationItemsDesktop />
            </Styles.DesktopNav>

            <Styles.MobileNav>
                <Styles.MobileNavHeader>
                    <Styles.MobileNavButton onClick={() => setNavigationOpen(!navigationOpen)}>
                        <StepStyles.Step isActive noPadding>
                            <Styles.Badge>0{currentStep}</Styles.Badge>
                            <TradeInAemLabel label={tradeInAemNavStepLabels[step]} />
                        </StepStyles.Step>
                        <IconWrapper.ToggleIconWrapper isDown={navigationOpen}>
                            <Icon variant="chevronDown" />
                        </IconWrapper.ToggleIconWrapper>
                    </Styles.MobileNavButton>
                    <Styles.FloatingNav visible={navigationOpen}>
                        <TradeInAemNavigationItemsMobile />
                    </Styles.FloatingNav>
                </Styles.MobileNavHeader>
            </Styles.MobileNav>
        </Styles.StickyWrapper>
    );
};
export default TradeInAemNavigation;
